(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-dispatch-explorer]:not([data-dispatch-ready])').forEach(scene => {
      const buttons = [...scene.querySelectorAll('[data-dispatch-choice]')];
      const panels = [...scene.querySelectorAll('[data-dispatch-panel]')];
      if (buttons.length !== 4 || panels.length !== 4) return;
      function select(index) {
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        panels.forEach((panel, i) => { panel.hidden = i !== index; panel.open = i === index; });
        scene.dataset.dispatchSelected = String(index);
      }
      buttons.forEach((button, index) => button.addEventListener('click', () => select(index)));
      select(0);
      scene.querySelector('.j-dispatch__days').hidden = false;
      scene.querySelector('.j-dispatch__journey').hidden = false;
      scene.dataset.dispatchReady = 'true';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
